import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'pct-common-progress-bar',
  imports: [MatProgressBar],
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-full',
    '[class.!absolute]': 'absolute()',
    '[class.bottom-0]': 'absolute()',
    '[class.left-0]': 'absolute()',
  },
})
export class ProgressBarComponent {
  readonly absolute = input(true);
}
